import { Fragment } from 'react'
import { Listbox, Transition } from '@headlessui/react'
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/react/20/solid'
import { useBranch } from '../contexts/BranchContext'
import { useAuth } from '../contexts/AuthContext'
import { cn } from '../utils/cn'

export default function BranchSelector() {
  const { branches, currentBranch, switchBranch } = useBranch()
  const { role } = useAuth()

  // Don't show if only one option (for non-owners) or no branches
  if ((role !== 'owner' && branches.length <= 1) || branches.length === 0) {
    return null
  }

  return (
    <Listbox value={currentBranch} onChange={(branch) => switchBranch(branch.id)}>
      <div className="relative">
        <Listbox.Button className="relative w-48 cursor-default rounded-md bg-white py-1.5 pl-3 pr-10 text-left text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:outline-none focus:ring-2 focus:ring-primary-500 sm:text-sm sm:leading-6">
          <span className="block truncate">
            {currentBranch ? (
              <span className={currentBranch.isAllBranches ? 'font-semibold text-blue-600' : ''}>
                {currentBranch.name}
              </span>
            ) : 'Select Branch'}
          </span>
          <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
            <ChevronUpDownIcon
              className="h-5 w-5 text-gray-400"
              aria-hidden="true"
            />
          </span>
        </Listbox.Button>

        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
            {branches.map((branch) => (
              <Listbox.Option
                key={branch.id}
                className={({ active }) =>
                  cn(
                    active ? 'bg-primary-600 text-white' : 'text-gray-900',
                    'relative cursor-default select-none py-2 pl-3 pr-9'
                  )
                }
                value={branch}
              >
                {({ selected, active }) => (
                  <>
                    <span
                      className={cn(
                        selected ? 'font-semibold' : 'font-normal',
                        branch.isAllBranches ? 'text-blue-600 font-semibold' : '',
                        active && branch.isAllBranches ? 'text-white font-semibold' : '',
                        'block truncate'
                      )}
                    >
                      {branch.name}
                      {branch.isAllBranches && (
                        <span className="ml-2 text-xs opacity-75">
                          (Business Overview)
                        </span>
                      )}
                    </span>

                    {selected ? (
                      <span
                        className={cn(
                          active ? 'text-white' : 'text-primary-600',
                          'absolute inset-y-0 right-0 flex items-center pr-4'
                        )}
                      >
                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                      </span>
                    ) : null}
                  </>
                )}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </div>
    </Listbox>
  )
} 